/**
 * Loaders 01–09 — pure-CSS organic loaders.
 * All share the <Cell> wrapper that injects the keyframes + gooey filter
 * defs on first mount.
 */
import React from 'react';
import { Cell } from './shared.jsx';

export const Loader01 = (p) => (
  <Cell {...p}><div className="ol-01" /></Cell>
);

export const Loader02 = (p) => (
  <Cell {...p}>
    <div className="ol-02"><span/><span/><span/><span/></div>
  </Cell>
);

export const Loader03 = (p) => (
  <Cell {...p}>
    <div className="ol-03"><div className="a"/><div className="b"/></div>
  </Cell>
);

export const Loader04 = (p) => (
  <Cell {...p}>
    <div className="ol-04"><div className="head"/><div className="drop"/></div>
  </Cell>
);

export const Loader05 = (p) => (
  <Cell {...p}><div className="ol-05" /></Cell>
);

export const Loader06 = (p) => (
  <Cell {...p}><div className="ol-06" /></Cell>
);

export const Loader07 = (p) => (
  <Cell {...p}>
    <div className="ol-07"><span/><span/><span/></div>
  </Cell>
);

export const Loader08 = (p) => (
  <Cell {...p}><div className="ol-08" /></Cell>
);

export const Loader09 = (p) => (
  <Cell {...p}>
    <div className="ol-09"><div className="c c1"/><div className="c c2"/></div>
  </Cell>
);
